/**
 * @deprecated Use utils/richText.js instead. This file re-exports for backward compatibility.
 */
export {
  createEmptyEditorState,
  HTMLToEditorState,
  EditorStateToHTML,
  formatAndSanitizeHTML,
  getSelectedBlockElement,
} from './richText'
